export const nativeLayerState = {};
